define([],
    function() {

        setCardsHeight = () => {
            let categories = document.querySelectorAll('.category');
            
            categories.forEach(category => {
                let cards = category.querySelector('.cards')
                let isActive = cards.classList.contains("active");

                cards.classList.add("no-transition");
                // momentarily show and save settings height so hide transition works
                if(isActive) cards.classList.remove("active");
                
                cards.style.height = null;
                let newCardsHeight = cards.offsetHeight;
                cards.style.height = `${newCardsHeight}px`;

                if(isActive) cards.classList.add("active");

                setTimeout(() => {
                    cards.classList.remove("no-transition");
                }, 500);
                
                    
            });
        }

        moveCards = () => {
            // EU and AU integrations only have a small number of integrations
            // This moves those integration cards into a single category for a lighter UI
            let allCards = document.querySelectorAll(".category .cards .card");
            let cardHolder = document.querySelector(".card-holder");
            let region = cardHolder.dataset.region;

            if(region === "na") return;

            allCards.forEach(card => {
                cardHolder.insertAdjacentElement("beforeend", card);
            })

            cardHolder.classList.remove("hide");
            document.querySelector(".integrations").classList.add("show");
        }

        toggleEventListeners = (sections) => {
            sections.forEach(section =>{
                section.addEventListener('click', function (e) {
                    let header = e.target;
                    let sibling = e.target.nextElementSibling;

                    header.classList.contains("active") ? header.classList.remove("active") : header.classList.add("active");
                    sibling.classList.contains("active") ? sibling.classList.remove("active") : sibling.classList.add("active");

                    setCardsHeight();
                });
            });
        }

        return {
            init: function() {
                moveCards();

                let authorizations = document.querySelectorAll('.authorizations_js');
                let categoryTitles = document.querySelectorAll('.category .title');
                let authorizationsWrappers = document.querySelectorAll('.active-integrations .auth-wrapper');
                let revokeButtons = document.querySelectorAll(".revoke");
                let revokeConfirmButtons = document.querySelectorAll(".confirm-revoke .confirm");
                let revokeDenyButtons = document.querySelectorAll(".confirm-revoke .deny");

                if(authorizationsWrappers.length) document.querySelector(".active-integrations").classList.remove("hide");

                revokeButtons.forEach(button => {
                    button.addEventListener("click", () => {
                        let id = button.getAttribute("data-id");
                        document.querySelector(`.confirm-revoke[data-id="${id}"`).style.display = "block";

                        let wrapper = document.querySelector(`.auth-user[data-id="${id}"`);
                        if(wrapper) wrapper.classList.add("no-revoke-hover");
                    })
                })

                revokeDenyButtons.forEach(button => {
                    button.addEventListener("click", () => {
                        let id = button.getAttribute("data-id");
                        document.querySelector(`.confirm-revoke[data-id="${id}"`).style.display = "none";

                        let wrapper = document.querySelector(`.auth-user[data-id="${id}"`);
                        if(wrapper) wrapper.classList.remove("no-revoke-hover");
                    })
                })

                revokeConfirmButtons.forEach(button => {
                    button.addEventListener("click", () => {
                        let id = button.getAttribute("data-id");
                        document.querySelector(`#revoke_${id}`).submit();

                        let wrapper = document.querySelector(`.auth-user[data-id="${id}"`);
                        if(wrapper) wrapper.classList.remove("no-revoke-hover");
                    })
                })

                document.querySelector("body").addEventListener("click", (event) => {
                    if(!event.target.classList.contains("revoke") 
                        && !event.target.classList.contains("confirm-revoke") 
                        && !event.target.classList.contains("options")) {
                        document.querySelectorAll(".confirm-revoke").forEach(element => {
                            element.style.display = "none";
                        })

                        document.querySelectorAll(".no-revoke-hover").forEach(element => {
                            element.classList.remove("no-revoke-hover")
                        })
                    }
                })

                setCardsHeight();

                toggleEventListeners(authorizations);
                toggleEventListeners(categoryTitles);

                window.addEventListener('resize', () => {
                    setCardsHeight();
                }, true);
            }
        };
    }
);
